module.exports = __webpack_public_path__ + "static/icon_pdf-0f9ea9aa7e37007977d77a0dda5a8121.svg";